import "@popperjs/core/dist/umd/popper.min.js";
import Tooltip from "bootstrap/js/dist/tooltip";
import { html } from "../base/_utils";

// Dev-site-only shortcut so editors can jump straight to the sheet tab feeding an element
/**
 * @param {string} targetSelector - A CSS selector string for the element the edit badge should be inserted before.
 * @param {string} dataSheet - The published CSV URL for the data source, used to extract the sheet's gid.
 * @param {string} sheetEditUrl - The Google Sheet's edit URL (the .../edit link, not the published CSV link).
 * @returns {void}
 */
export default function prependEditDataLink(targetSelector, dataSheet, sheetEditUrl) {
    const isDevSite = window.location.hostname.includes("summitathletics-dev.com");
    const isMarkupReview = window.location.hostname.includes("markup.io");

    if (!isDevSite && !isMarkupReview) return;

    const targetEl = document.querySelector(targetSelector);
    if (!targetEl) return;

    const gid = new URL(dataSheet).searchParams.get("gid");

    targetEl.insertAdjacentHTML(
        "beforebegin",
        html`<a
            class="edit-badge position-relative bg-placeholder text-white text-decoration-underline link-underline-white d-flex justify-content-center align-items-center w-100 py-2 px-3 mb-2 bg-opacity-80-hover link-underline-opacity-0-hover"
            href="${sheetEditUrl}?gid=${gid}#gid=${gid}"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-title="Changes made in the sheet will automatically update both live and test sites"
            target="_blank"
            rel="noopener noreferrer"
            style="border-radius: 10px !important; z-index: 999;"
            >EDIT DATA VIA GOOGLE SHEET HERE <span class="visually-hidden">(opens in new tab)</span></a
        >`,
    );

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => new Tooltip(el));
}
